const PaperClip = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M13.1817 3.41425C14.7438 1.85215 17.2764 1.85215 18.8385 3.41425C20.4006 4.97635 20.4006 7.50901 18.8385 9.0711L9.9997 17.9099C9.02339 18.8862 7.44048 18.8862 6.46417 17.9099C5.48786 16.9336 5.48786 15.3507 6.46417 14.3744L15.303 5.53557C15.6935 5.14504 16.3267 5.14504 16.7172 5.53557C17.1077 5.92609 17.1077 6.55926 16.7172 6.94978L7.87838 15.7886C7.68312 15.9839 7.68312 16.3005 7.87838 16.4957C8.07364 16.691 8.39022 16.691 8.58549 16.4957L17.4243 7.65689C18.2054 6.87584 18.2054 5.60951 17.4243 4.82846C16.6433 4.04741 15.3769 4.04741 14.5959 4.82846L5.75706 13.6673C4.39022 15.0341 4.39022 17.2502 5.75706 18.617C7.12389 19.9839 9.33997 19.9839 10.7068 18.617L19.803 9.52085C20.1935 9.13033 20.8267 9.13033 21.2172 9.52085C21.6077 9.91137 21.6077 10.5445 21.2172 10.9351L12.121 20.0313C9.97314 22.1791 6.49073 22.1791 4.34285 20.0313C2.19496 17.8834 2.19496 14.401 4.34285 12.2531L13.1817 3.41425Z"
        fill="#57585C"
      />
    </svg>
  );
};

export default PaperClip;
